import React, { useEffect, useState, useRef, useMemo } from 'react';
import { Col, Row } from 'antd';
import { useDrag, useDrop, useDragLayer } from 'react-dnd';
import { Link } from 'react-router-dom';
import { Modal, Button, IconButton, FormLabel ,FormHelperText  , TextField, Tooltip} from '@mui/material';
import {  get , find , has , filter } from "lodash"
import styled from 'styled-components';
import VideoLinks from 'containers/videoLinks';
import { videoLink } from "utils/assets/images"
import { useHowToVideos } from 'store/howToVideos/selectors';
import { useDispatch } from 'react-redux';
import { handleListHowToVideos } from "store/howToVideos/thunks"
import { Add, Edit, Delete, Close, DragIndicator } from '@mui/icons-material'
import { DeleteModal } from 'components/Dialog';
import VideoPicker from "components/AdminBooks/VideoPicker";
import PageImagePicker from "components/AdminBooks/PageImagePicker"
import Loading from 'components/Loading';
import { handleCreateHowToVideos , handleDeleteHowToVideos , handleUpdateHowToVideos, handleBatchUpdateHowToVideosOrder } from "store/howToVideos/thunks"
import { useDndScrolling } from 'react-dnd-scrolling';

const isTouchDevice = () => {
    return 'ontouchstart' in window || navigator.maxTouchPoints > 0;
};

const ItemType = 'VIDEO_CARD';

const layerStyles = {
    position: 'fixed',
    pointerEvents: 'none',
    zIndex: 100,
    left: 0,
    top: 0,
    width: '100%',
    height: '100%',
};

function getItemStyles(initialOffset, currentOffset) {
    if (!initialOffset || !currentOffset) {
        return {
            display: 'none',
        };
    }

    const { x, y } = currentOffset;
    const transform = `translate(${x}px, ${y}px)`;
    return {
        transform,
        WebkitTransform: transform,
        opacity: 0.9,
        width: '280px',
        height: 'auto'
    };
}

const style = {};
const TopRow = styled(Row)`
    border: 0.5px solid #3c393957;
    box-sizing: border-box;
    padding-left: 10px;
    padding-right: 10px;
    display: flex;
    justify-content: space-between;
    align-items: center;
`;

const ModalContent = styled.div`
    left: 50%;
    width:70vw;
    padding: 0px 24px;
    position: absolute;
    min-height:350px;
    top: 50%;
    transform: translate(-50%, -50%);
    background-color:#fff;
    padding:20px;
     @media only screen and (max-width: 600px) {
        width: 90%;
    }
`;
const ModalConfigArea = styled.div`
    min-height:75vh;
    max-height:90vh;
    overflow:auto;
    margin-top:10px;
`;
const TitleText = styled.span`
    font-size: 18px;
    color: black;
    font-weight:600;
`;
const ImageContainer = styled.div`
    img{
        max-height:100px;
    }
`;

const EditVideo = ({ editResourseModal, onCloseModal, item }) => {
    const [resourceVideo, setResourcesVideo] = useState({})
    const [poster, setPoster] = useState('')
    const [title, setTitle] = useState('')
    const [video, setVideo] = useState('')
    const [loading, setloading] = useState(false)
    const [error, setError] = useState([])
    const dispatch = useDispatch()
    useEffect(() => {
        if (item) {
            setResourcesVideo(item)
            setPoster(get(item, "poster", ''))
            setTitle(get(item, "title", ''))
            setVideo(get(item, "video", ''))
            setError([])
        }
    }, [item])
    const onCreateOrUpdate = async () => {
        let err = []
        if (!video) {
            err.push({
                key: "video", message: 'Video required!'
            })
        }
        if (!poster) {
            err.push({
                key: "poster", message: 'Poster image required!'
            })
        }
        if (!title) {
            err.push({
                key: "title", message: 'Title  required!'
            })
        }
        setError(err)
        if (err.length == 0) {
            setloading(true)
             if(has(item,"id")){
                const data = {
                    ...item,
                    poster,
                    video,
                    title
                }
             await dispatch(handleUpdateHowToVideos(data))
             }else{
                const data = {
                    poster,
                    video,
                    title
                }
             await dispatch(handleCreateHowToVideos(data))
             }
            setloading(false)
            onCloseModal()
        }
    }
    return (<Modal
        open={editResourseModal}
        onClose={() => { }}
        style={{ height: '100%', width: '100%' }}
    >
        <ModalContent>
            <Row style={{ justifyContent: "space-between" }}>
                <TitleText>{has(item, "id") ? 'Update Video' : 'Add Video'}</TitleText>
                <IconButton onClick={onCloseModal} style={{ padding: 0 }}>
                    <Close color="secondary" />
                </IconButton>
            </Row>
            <ModalConfigArea>
                <Row>
                    <Col lg={12} xs={24}>
                        <FormLabel style={{color:'black'}} component="legend">Video</FormLabel>
                        <VideoPicker
                            src={video}
                            onChange={(item) => { 
                                setVideo(item.url) 
                                setError(filter(error,e=>e.key !="video"))
                             }}
                        />
                    </Col>
                    <Col lg={12} xs={24} style={{ paddingLeft: 10, paddingTop: 10 }}>
                        <FormLabel style={{ color: 'black' }} component="legend">Poster for videos:</FormLabel>
                        <ImageContainer>
                        <PageImagePicker
                            src={poster}
                            path={`/poster}`}
                            // style={{ height: 270, marginBottom: 24 }}
                            onChange={item => { 
                                setPoster(item.url)
                                setError(filter(error,e=>e.key !="poster"))
                             }}
                            hasDescription={false}
                        />
                        </ImageContainer>
                        {has(item, "id")?<Row justify="start" style={{ marginBottom: 10, }}>
                            <TextField
                                id="id"
                                name="id"
                                label="Id"
                                InputLabelProps={{ shrink: true }}
                                type="text"
                                disabled
                                variant="outlined"
                                value={get(resourceVideo, "id")}
                            />
                        </Row>:null}
                        <Row justify="start" style={{ marginBottom: 30, }}>
                            <TextField
                                id="title"
                                name="title"
                                error={find(error, ['key', 'title'])}
                                label="Title"
                                InputLabelProps={{ shrink: true, required: true }}
                                required
                                type="text"
                                variant="outlined"
                                onChange={e => {
                                    setTitle(e.target.value)
                                    setError(filter(error,e=>e.key !="title"))
                                }}
                                value={title}
                            />
                        </Row>
                        {error.length > 0 ? <Row style={{ marginTop: 10, marginRight: 0, marginLeft: 0, flexDirection: "column", display: "flex" }}>
                            {error.map(v => (<FormHelperText key={v.key} error>
                                * {get(v, "message")}
                            </FormHelperText>))}
                        </Row> : null}
                        <Row gutter={[24, 24]} style={{ marginTop: 10, marginRight: 0, marginLeft: 0 }}>
                            <Button disabled={loading} fullWidth onClick={onCreateOrUpdate} variant="contained" color="primary">
                                {loading ? <Loading white size={15} /> : null}
                                {has(item, "id") ? "Update" : "Create"} </Button>
                        </Row>
                    </Col>
                </Row>
            </ModalConfigArea>
        </ModalContent>
    </Modal>)
}

const CustomDragLayer = ({ videos }) => {
    const {
        isDragging,
        item,
        initialOffset,
        currentOffset,
    } = useDragLayer((monitor) => ({
         item: monitor.getItem(),
        initialOffset: monitor.getInitialClientOffset(),
        currentOffset: monitor.getClientOffset(),
        isDragging: monitor.isDragging(),
    }));
    
    const itemData = useMemo(() => find(videos, ['id', item?.id]) || item, [videos, item]);
    
    if (!isDragging) {
        return null;
    }

    return (
        <div style={layerStyles}>
            <div style={getItemStyles(initialOffset, currentOffset)}>
                <div className="cstmLrnRow" style={{ width: '100%' }}>
                    {/* <TopRow style={{ justifyContent: 'flex-end' }}>
                        <IconButton style={{ padding: 0 }}>
                            <Delete color="secondary" />
                        </IconButton>
                    </TopRow> */}
                    <div className="ShowDetailBnr card-resource" style={{ cursor: "pointer" }}>
                        <div className="card-resource-overlay"></div>
                        <img src={itemData?.poster} style={{ width: '100%', height: 'auto' }} />
                        <Link className="ShowDetail" style={{ cursor:"pointer"}} ><img src={videoLink} /></Link>
                        <div className="card-resource-details fadeIn-bottom">
                            <h3 className="card-resource-title">{itemData?.title} <Edit /> </h3>
                        </div>
                    </div>
                    <div className="learnCntLink"><a>{itemData?.title}</a></div>
                </div>
            </div>
        </div>
    );
};

const DraggableVideoCard = ({ item, index, moveCard, handleEdit, setSelectedItem, setDeleteToggle, scrollContainerRef, onDragPositionChange }) => {
    const ref = useRef(null);
    const dragHandleRef = useRef(null);
    const lastMoveTime = useRef(0);
    const moveThrottleDelay = 100;

    const [, drop] = useDrop({
        accept: ItemType,
        hover: (draggedItem, monitor) => {
            if (!ref.current) {
                return;
            }
            const dragIndex = draggedItem.index;
            const hoverIndex = index;

            if (dragIndex === hoverIndex) {
                return;
            }

            const clientOffset = monitor.getClientOffset();
            if (!clientOffset) {
                return;
            }

            if (onDragPositionChange && scrollContainerRef?.current) {
                const containerRect = scrollContainerRef.current.getBoundingClientRect();
                onDragPositionChange(clientOffset, containerRect);
            }

            const now = Date.now();
            if (now - lastMoveTime.current < moveThrottleDelay) {
                return;
            }

            const hoverBoundingRect = ref.current.getBoundingClientRect();
            const hoverMiddleY = (hoverBoundingRect.bottom - hoverBoundingRect.top) / 2;
            const hoverClientY = clientOffset.y - hoverBoundingRect.top;

            if (dragIndex < hoverIndex && hoverClientY < hoverMiddleY) {
                return;
            }
            if (dragIndex > hoverIndex && hoverClientY > hoverMiddleY) {
                return;
            }

            moveCard(dragIndex, hoverIndex);
            draggedItem.index = hoverIndex;
            lastMoveTime.current = now;
        },
    });

    const [{ isDragging }, drag, preview] = useDrag({
        type: ItemType,
        item: { id: item.id, index },
        collect: (monitor) => ({
            isDragging: monitor.isDragging(),
        }),
    });

    drag(dragHandleRef);
    drop(ref);
    
    useEffect(() => {
        const emptyImage = new Image();
        emptyImage.src = '';
        emptyImage.style.opacity = 0;
        preview(emptyImage);
    }, [preview]);

    return (
        <Col xs={12} sm={12} md={8} className="cstmLrnRow" ref={ref} style={{ opacity: isDragging ? 0.2 : 1, transition: 'opacity 0.2s ease' }}>
            <TopRow>
                <Tooltip title="Drag to reorder" arrow>
                    <IconButton 
                        ref={dragHandleRef}
                        style={{ 
                            padding: 0, 
                            cursor: isDragging ? 'grabbing' : 'grab'
                        }}
                        onMouseDown={(e) => {
                            e.stopPropagation();
                        }}
                    >
                        <DragIndicator style={{ color: '#666' }} />
                    </IconButton>
                </Tooltip>
                <IconButton onClick={() => {
                    setSelectedItem(item)
                    setDeleteToggle(true)
                }} style={{ padding: 0 }}>
                    <Delete color="secondary" />
                </IconButton>
            </TopRow>
            <div className="ShowDetailBnr card-resource" style={{ cursor: "pointer" }} onClick={() => handleEdit(item)}>
                <div className="card-resource-overlay"></div>
                <img src={item.poster} />
                <Link className="ShowDetail" style={{ cursor:"pointer"}} ><img src={videoLink} /></Link>
                <div className="card-resource-details fadeIn-bottom">
                    <h3 className="card-resource-title">{item.title} <Edit /> </h3>
                </div>
            </div>
            <div className="learnCntLink"><a>{item.title}</a></div>
        </Col>
    );
};

const ScrollableVideoList = ({
  videos,
  moveCard,
  handleEdit,
  setSelectedItem,
  setDeleteToggle,
}) => {
  const scrollRef = useRef(null);
  const scrollAnimationFrame = useRef(null);
  const isScrolling = useRef(false);
  const currentScrollSpeed = useRef(0);
  
  useDndScrolling(scrollRef, { 
    interval: 10, 
    speed: 30,
    threshold: 80
  });

  const handleDragPositionChange = (clientOffset, containerRect) => {
    if (!scrollRef?.current || !clientOffset) {
      isScrolling.current = false;
      currentScrollSpeed.current = 0;
      if (scrollAnimationFrame.current) {
        cancelAnimationFrame(scrollAnimationFrame.current);
        scrollAnimationFrame.current = null;
      }
      return;
    }

    const scrollThreshold = 100;
    const maxScrollSpeed = 30;
    
    const distanceFromTop = clientOffset.y - containerRect.top;
    const distanceFromBottom = containerRect.bottom - clientOffset.y;
    
    let scrollAmount = 0;
    
    if (distanceFromTop < scrollThreshold) {
      const factor = Math.max(0, (scrollThreshold - distanceFromTop) / scrollThreshold);
      scrollAmount = -maxScrollSpeed * factor;
    } else if (distanceFromBottom < scrollThreshold) {
      const factor = Math.max(0, (scrollThreshold - distanceFromBottom) / scrollThreshold);
      scrollAmount = maxScrollSpeed * factor;
    }

    currentScrollSpeed.current = scrollAmount;
    
    if (scrollAmount !== 0 && !isScrolling.current) {
      isScrolling.current = true;
      const scrollLoop = () => {
        if (!scrollRef?.current || currentScrollSpeed.current === 0) {
          isScrolling.current = false;
          scrollAnimationFrame.current = null;
          return;
        }

        const scrollContainer = scrollRef.current;
        const currentScroll = scrollContainer.scrollTop;
        const newScroll = Math.max(
          0,
          Math.min(
            scrollContainer.scrollHeight - scrollContainer.clientHeight,
            currentScroll + currentScrollSpeed.current
          )
        );
        
        scrollContainer.scrollTop = newScroll;
        
        scrollAnimationFrame.current = requestAnimationFrame(scrollLoop);
      };
      
      scrollAnimationFrame.current = requestAnimationFrame(scrollLoop);
    } else if (scrollAmount === 0 && isScrolling.current) {
      isScrolling.current = false;
      currentScrollSpeed.current = 0;
    }
  };

  useEffect(() => {
    return () => {
      if (scrollAnimationFrame.current) {
        cancelAnimationFrame(scrollAnimationFrame.current);
      }
    };
  }, []);

  return (
    <div 
      ref={scrollRef} 
      className="learnContent" 
      style={{ 
        maxHeight: '75vh', 
        overflowY: 'auto', 
        overflowX: 'hidden',
        padding: '15px',
        WebkitOverflowScrolling: 'touch',
        willChange: 'scroll-position'
      }}
    >
      <Row gutter={[25, 0]} className="4545 learnDetail">
        {videos.map((item, index) => (
          <DraggableVideoCard
            key={item.id}
            item={item}
            index={index}
            moveCard={moveCard}
            handleEdit={handleEdit}
            setSelectedItem={setSelectedItem}
            setDeleteToggle={setDeleteToggle}
            scrollContainerRef={scrollRef}
            onDragPositionChange={handleDragPositionChange}
          />
        ))}
      </Row>
    </div>
    );
};

export default function LearnScreen() {
    const howToVideos = useHowToVideos()
    const [videos, setVideos] = useState([])
    const [loading, setLoading] = useState(false)
    const [deleteToggle, setDeleteToggle] = useState(false)
    const [selectedItem,setSelectedItem] = useState(null)
    const dispatch = useDispatch()
    const [videoModalInfo, setVideoModalInfo] = React.useState({
        open: false,
        item: null
    });
    const isTouch = useMemo(() => isTouchDevice(), []);

    useEffect(() => {
    //   if (howToVideos?.length == 0) {
      dispatch(handleListHowToVideos())
    //   }
    }, [])
    const onAdd = () => {
        setVideoModalInfo({open: true, item: {}})
    }
    const handleEdit = (item) => {
        setVideoModalInfo({open: true, item})
    }

    useEffect(() => {
        const sortedVideos = [...howToVideos].sort((a, b) => {
        const orderA = a.order ?? Number.MAX_SAFE_INTEGER;
        const orderB = b.order ?? Number.MAX_SAFE_INTEGER;
        return orderA - orderB;
        });
        
        setVideos(sortedVideos.map((v, idx) => ({ 
        ...v, 
        order: v.order !== undefined ? v.order : idx 
        })));
    }, [howToVideos]);

    const moveCardRef = useRef(null);
    
    useEffect(() => {
        return () => {
            if (moveCardRef.current) {
                clearTimeout(moveCardRef.current);
            }
        };
    }, []);
    
    const moveCard = (fromIndex, toIndex) => {
        if (fromIndex === toIndex) {
            return;
        }
        
        setVideos(prevVideos => {
            const updatedItems = [...prevVideos];
            const [movedItem] = updatedItems.splice(fromIndex, 1);
            updatedItems.splice(toIndex, 0, movedItem);
            
            if (moveCardRef.current) {
                clearTimeout(moveCardRef.current);
            }
            
            moveCardRef.current = setTimeout(() => {
                const videoOrders = updatedItems.map((item, index) => ({
                    id: item.id,
                    order_num: index
                }));

                dispatch(handleBatchUpdateHowToVideosOrder(videoOrders)).catch((error) => {
                    console.error('Failed to update video order:', error);
                    dispatch(handleListHowToVideos());
                });
            }, 300);
            
            return updatedItems;
        });
    };

    const onDeleteItem = async() =>{
        if(has(selectedItem,"id")){
            setLoading(true)
            await dispatch(handleDeleteHowToVideos(selectedItem.id))
            setLoading(false)
        }
        setSelectedItem(null)
        setDeleteToggle(false)
    }
    return (
        <>
            <EditVideo
                editResourseModal={videoModalInfo.open}
                item={videoModalInfo.item}
                onCloseModal={() => setVideoModalInfo({ open: false, item: null })}
            />
            <DeleteModal
                deleteToggle={deleteToggle}
                setDeleteToggle={setDeleteToggle}
                onDelete={onDeleteItem}
                message={`Are you sure you want to delete "${get(selectedItem,"title")}"?`}
                loading={loading} />
            <Button variant="contained" color="primary" style={{ marginTop: 24 }} onClick={onAdd}>
                <Add /> Add videos
            </Button>

                <Row className="learnContentUpr" gutter={[25, 0]}>
                    <Col xs={24} sm={24} md={6} className="searchMob">
                    </Col>

                    <Col xs={24} sm={24} md={18}>
                        <ScrollableVideoList
                            videos={videos}
                            moveCard={moveCard}
                            handleEdit={handleEdit}
                            setSelectedItem={setSelectedItem}
                            setDeleteToggle={setDeleteToggle}
                        />
                    </Col>

                    <Col xs={24} sm={24} md={6} className="searchWeb">
                        <VideoLinks Items={videos} onClick={handleEdit} />
                    </Col>
                </Row>
                <CustomDragLayer videos={videos} />
        </>
    );
}
